import * as React from 'react'
import styled from 'styled-components'
import * as constants from 'static/constants'

interface IProps {
  classNames?: 'pickupLocation' | 'meetupPlace' | 'otherRequests' | string
}

export const WeeklyInfoCard: React.FC<IProps> = ({ children, classNames }) => {
  return <Wrapper className={classNames}>{children}</Wrapper>
}

const Wrapper = styled.div`
  display: -webkit-box;
  font-size: 12px;
  word-break: keep-all;
  overflow-wrap: break-word;
  overflow-wrap: anywhere;
  -webkit-line-clamp: 4;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  padding: 4px;
  border-radius: 4px;
  margin-top: 4px;
  line-height: 1.5;

  &::before {
    display: block;
    content: 'Other Requests';
    font-size: 10px;
    color: ${constants.COLORS.subText};
  }
  &:empty {
    padding: 0;
    margin: 0;
    &::before {
      display: none;
    }
  }

  &.pickupLocation {
    &::before {
      content: 'Pickup Location';
    }
    background: ${constants.COLORS.successBG2};
  }
  &.meetupPlace {
    display: block;
    background: ${constants.COLORS.successBG2};
    border: 1px solid ${constants.COLORS.white};
    & + .paymentDetailContainer {
      margin-top: 4px;
    }
    &::before {
      content: 'Meetup Place';
    }
    a {
      color: ${constants.COLORS.primary};
      text-decoration: underline;
    }
    p {
      white-space: pre-wrap;
      word-break: keep-all;
      overflow-wrap: break-word;
      overflow-wrap: anywhere;
      -webkit-line-clamp: 4;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-box-orient: vertical;
      line-height: 1.5;
    }
  }
`
